var map = {
	"./Frieda.jpeg": 9385,
	"./JSPS.png": 1733,
	"./OCPC.png": 8009,
	"./Pradeep.jpeg": 1294,
	"./Sabrina.jpeg": 2257,
	"./c101.png": 1618,
	"./c102.png": 6959,
	"./c103.png": 6472,
	"./c104.png": 6824,
	"./c111.png": 2166,
	"./c112.png": 7395,
	"./c113.png": 3685,
	"./c114.png": 3470,
	"./c121.png": 1473,
	"./c122.png": 1667,
	"./c123.png": 9663,
	"./c23.png": 979,
	"./c24.png": 7652,
	"./c31.png": 5150,
	"./c32.png": 9816,
	"./c33.png": 2078,
	"./c34.png": 4933,
	"./c41.png": 6027,
	"./c42.png": 3404,
	"./c43.png": 6540,
	"./c44.png": 1596,
	"./c51.png": 4402,
	"./c52.png": 9405,
	"./c53.png": 8986,
	"./c54.png": 1276,
	"./c61.png": 2829,
	"./c62.png": 3339,
	"./c63.png": 6123,
	"./c64.png": 1954,
	"./c71.png": 3238,
	"./c72.png": 1573,
	"./c73.png": 4973,
	"./c74.png": 7551,
	"./c81.png": 7579,
	"./c82.png": 4085,
	"./c83.png": 705,
	"./c84.png": 1006,
	"./c91.png": 1797,
	"./c92.png": 3006,
	"./c93.png": 1513,
	"./c94.png": 1939,
	"./china.png": 7025,
	"./cr22.png": 5184,
	"./eramus.jpg": 2139,
	"./erasmus+.png": 9338,
	"./get_involved_canada.png": 1415,
	"./icon.png": 7334,
	"./india1.png": 5281,
	"./india2.png": 9913,
	"./india3.png": 3900,
	"./india4.png": 3830,
	"./india5.png": 24,
	"./india6.png": 2520,
	"./integrated_into_projects.png": 9649,
	"./interdesciplinary_work.png": 6411,
	"./international_enviorment.png": 619,
	"./lectures.png": 7323,
	"./mitacs.png": 6390,
	"./partner.jpg": 3523,
	"./question.jpg": 9902,
	"./service1.png": 6440,
	"./service10.png": 2087,
	"./service11.png": 8330,
	"./service12.png": 4033,
	"./service13.png": 9105,
	"./service14.png": 8893,
	"./service15.png": 6214,
	"./service16.png": 3336,
	"./service17.png": 2207,
	"./service2.png": 654,
	"./service3.png": 8680,
	"./service4.png": 7410,
	"./service5.png": 5410,
	"./service6.png": 4581,
	"./service7.png": 7570,
	"./service8.png": 4838,
	"./service9.png": 6758,
	"./soft_skills.png": 998,
	"./south_africa.png": 1214,
	"./st1.jpg": 4026,
	"./st10.jpg": 371,
	"./st2.jpg": 9360,
	"./st3.jpg": 7195,
	"./st4.jpg": 7373,
	"./st5.jpg": 294,
	"./st6.jpg": 8069,
	"./st7.jpg": 1934,
	"./student.jpg": 5600,
	"./tud.png": 1028,
	"./tus.png": 704,
	"./usc.png": 1925,
	"./visiting_staff.jpg": 4846,
	"./wut.png": 2420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;